import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Collect } from 'contracts/Collects';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_COLLECT_',
  }
);

export interface FetchCollectState {
  data: Collect | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCollectRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Collect;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCollectState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCollectState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCollectState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCollectState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCollectState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCollect = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCollectTypes = Types;
export const FetchCollectActions = Creators;
